import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-50px" },
  transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] }
};

const staggerItem = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

export const Contact = () => {
  return (
    <div className="min-h-screen bg-white overflow-hidden">
      <Navbar />
      
      {/* Hero Section */}
      <section 
        className="pt-32 pb-16 md:pt-40 md:pb-24"
        data-testid="contact-hero"
      >
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
          <motion.p 
            className="text-xs font-bold tracking-[0.2em] uppercase text-neutral-500 mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Get In Touch
          </motion.p>
          <motion.h1 
            className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight uppercase mb-6"
            style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Contact Us
          </motion.h1>
          <motion.p 
            className="text-lg md:text-xl text-neutral-600 max-w-2xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Ready to discuss your project requirements? Our team is here to help with technical inquiries, quotes, and partnership opportunities.
          </motion.p>
        </div>
      </section>

      {/* Contact Details */}
      <section className="py-16 md:py-24 border-t border-neutral-200" data-testid="contact-details">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {[
              { icon: MapPin, title: 'Location', content: ['Cnr All Black & Tile Rd', 'Anderbolt, Boksburg', 'Gauteng, 1459'] },
              { icon: MapPin, title: 'Location', content: ['Cnr Bird and Guile Rd', 'Lilianton, Boksburg', 'Gauteng, 1459'] },
              { icon: Phone, title: 'Phone', content: ['010 894 6624'] },
              { icon: Mail, title: 'Email', content: ['enquires@catworth.co.za'] },
            ].map((item, index) => (
              <motion.div 
                key={item.title}
                {...staggerItem}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="flex items-center gap-3 mb-4">
                  <item.icon size={20} className="text-neutral-400" />
                  <h3 className="text-xs font-bold tracking-[0.2em] uppercase text-neutral-500">
                    {item.title}
                  </h3>
                </div>
                <div className="text-lg text-neutral-800">
                  {item.content.map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
